import { useState } from "react";
import { useLicensingContext } from "../context/useLicensingContext";
import { useProjectContext } from "../context/useProjectContext";
import { showGenericError, showSuccessNotification } from "../helper/Notifications";

const usePurchaseSubscription = () => {
  const { purchaseSubscription, subscription } = useLicensingContext();
  const { selectedProject } = useProjectContext();
  const [isLoading, setIsLoading] = useState(false);
  const [annualPricing, setAnnualPricing] = useState(false);

  const billingInterval = subscription?.interval;
  const effectiveAnnual = billingInterval ? billingInterval === "year" : annualPricing;

  const handlePurchase = async (planId, currency, onSuccess, onError) => {
    if (!selectedProject) return;
    setIsLoading(true);
    try {
      const result = await purchaseSubscription(selectedProject.id, planId, currency);
      if (result.redirect) { window.location = result.url; return; }
      setIsLoading(false);
      showSuccessNotification("You have successfully subscribed to the product!");
      if (onSuccess) onSuccess();
    } catch (error) {
      setIsLoading(false);
      showGenericError();
      if (onError) onError(error);
    }
  };

  return {
    handlePurchase,
    isLoading,
    annualPricing,
    setAnnualPricing,
    effectiveAnnual,
    billingInterval,
  };
};

export default usePurchaseSubscription;